<template>
  <div class="container">
    <div class="menu-container">

      <!-- 主菜单 -->
      <div class="main-menu">
        <div
          v-for="(subcategories, category) in categories" 
          :key="category"
          class="menu-item"
          :class="{ active: activeCategory === category }"
          @mouseenter="setActiveCategory(category)"   
          @mouseleave="tryClearActiveCategory"
          ref="menuItems"
            v-on:click.prevent="queryCategory(category, '全部', '全部')">
          {{ category }}
        </div>
      </div>
      
      <transition name="fade">
        <div class="submenu-wrapper"
          v-if="activeCategory && 
          activeCategory !== '其他' &&
          activeCategory !== '全部' && 
          categories[activeCategory]"
          :style="submenuPosition">
          <div class="submenu-container"
            @mouseenter="keepSubmenu"
            @mouseleave="clearActiveCategory">
            <div class="submenu-category" 
                v-for="(items, subcategory) in filteredSubcategories" :key="subcategory">
              <div class="submenu-row">
                <div class="submenu-header" 
                    v-on:click.prevent="queryCategory(activeCategory, subcategory, '全部')">
                    {{ subcategory }}
                </div>
                <div class="submenu-items">
                    <span class="submenu-item" 
                        v-for="item in safeGetItems(items)" :key="item"
                        v-on:click.prevent="queryCategory(activeCategory, subcategory, item)">
                        {{ item }}
                    </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition> 

    </div>
  </div>

   <div class="stylesContainer">
        <div class="styleRow">
            <label class="styleItem" v-for="styleStr in stylesArr" :key = styleStr>
                <input type="checkbox" 
                :value="styleStr" 
                v-model="selectedStyles"
                @change="querystyle">
                {{styleStr}}
            </label>        
        </div>
   </div>

  <div class="search">      
    <form class="searchContainer">
        <input v-model="keyword" type="text">
        <button v-on:click.prevent="searchRes">搜索</button>
    </form>
  </div>

</template>

<script>
import axios from 'axios'

export default {
name: 'Menu',
data() {
    return {
        activeCategory: null,
        familiesData: null,
        dataLoaded: false,
        keepSubmenuActive: false,
        clearTimer: null,
        activeItemLeft: 0,
        selectedStyles: [],
        keyword: '',
        loading: false,
        error: null
    }
},

computed: {
    stylesArr(){
        if (!this.familiesData || !this.familiesData.STYLE || !this.familiesData.STYLE.data) {
            return {};
        }
        return this.familiesData.STYLE.data;
    },

    categories() {
        if (!this.familiesData || !this.familiesData.CATEGORIES || !this.familiesData.CATEGORIES.data) {
            return {};
        }
        return this.familiesData.CATEGORIES.data;
    },

    filteredSubcategories() {
        if (!this.activeCategory || !this.categories[this.activeCategory]) {
            return {};
        }
        
        const result = {};
        for (const [key, value] of Object.entries(this.categories[this.activeCategory])) {
            if (key !== '全部') {
                result[key] = value;
            }
        }
        return result;
    },
    
    submenuPosition() {
        return {
            left: `${this.activeItemLeft}px`
        };
    }
},

methods: {
    safeGetItems(items) {
        return Array.isArray(items) ? items.filter(item => item !== '全部') : [];
    },

    setActiveCategory(category) {
        if (this.clearTimer) {
            clearTimeout(this.clearTimer);
            this.clearTimer = null;
        }
        this.activeCategory = category;
        this.keepSubmenuActive = false;
        
        const index = Object.keys(this.categories).indexOf(category);
        if (index !== -1 && this.$refs.menuItems && this.$refs.menuItems[index]) {
            const menuItem = this.$refs.menuItems[index];
            this.activeItemLeft = menuItem.offsetLeft;
        }
    },

    tryClearActiveCategory() {
        if (!this.keepSubmenuActive) {
            this.clearTimer = setTimeout(() => {
                if (!this.keepSubmenuActive) {
                this.activeCategory = null;
                }
            }, 150);
        }
    },

    clearActiveCategory() {
        this.keepSubmenuActive = false;
        this.activeCategory = null;
    },

    keepSubmenu() {
        this.keepSubmenuActive = true;
        if (this.clearTimer) {
            clearTimeout(this.clearTimer);
            this.clearTimer = null;
        }
    },

    queryCategory(fama, famb, famc){
        const params = {...this.$route.query};
        delete params.search;
        params.page = 1;
        if(fama){ params.familya = fama; };
        if(famb){ params.familyb = famb; };
        if(famc){ params.familyc = famc; };
        this.$router.push({query: params});
    },

    querystyle(){
        const params = {
            ...this.$route.query,
            style: this.selectedStyles
        };
        
        if (this.selectedStyles.length === 0) {
            delete params.style;
        }
        
        this.$router.push({query: params});
    },

    searchRes(){
        const params = {...this.$route.query};
        Object.keys(params).forEach(key => {
            delete params[key];
        });
        if(this.keyword){ params.search = this.keyword; }
        this.$router.push({query: params});
    },

    // 新增：从API获取分类数据
    async fetchCategoriesData() {
        this.loading = true;
        this.error = null;
        
        try {
            // 根据你的实际API地址进行调整
            const response = await axios.get('/api/categories/');
            
            if (response.data) {
                this.familiesData = response.data;
                this.dataLoaded = true;
            } else {
                throw new Error('API返回数据为空');
            }
            
        } catch (error) {
            console.error('获取分类数据失败:', error);
            this.error = '加载分类数据失败，请稍后重试';
            
            // 设置默认的空数据结构，避免页面崩溃
            this.familiesData = { 
                STYLE: { data: [] }, 
                CATEGORIES: { data: {} }, 
                _metadata: {} 
            };
            this.dataLoaded = true;
        } finally {
            this.loading = false;
        }
    },

    // 新增：重试获取数据
    retryFetchData() {
        this.fetchCategoriesData();
    }
},

async created() {
    // 替换原来的本地文件加载
    await this.fetchCategoriesData();
},

beforeDestroy() {
    if (this.clearTimer) {
        clearTimeout(this.clearTimer);
    }
}
}
</script>

<style scoped>

.container {
    display: flex;
    width: 100%;
    min-width: 1024px;
    z-index: 1000;
}

.menu-container {
    width: 1280px;
    margin: 0 auto;
    position: relative;
    display: inline-block;
}

.main-menu {
    margin-top: 5px;
    display: flex;
    background-color: rgb(250, 250, 250);
    position: relative;
}

.menu-item {
    padding: 10px 20px;
    color: gray;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    white-space: nowrap;
    transition: all 0.2s ease;
    position: relative;
}

.menu-item:hover, .menu-item.active {
    border-bottom: 2px solid #45b5b5;
    color: #45B5B5;
    background-color: rgba(69, 181, 181, 0.3);
}

.submenu-wrapper {
    position: absolute;
    top: 100%;
    z-index: 1000;
    min-width: max-content;
}

.submenu-container {
    background: white;
    padding: 15px 15px  15px 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    display: inline-block;
}

.submenu-row {
    display: flex;
    align-items: flex-start;
}

.submenu-header {
    cursor: pointer;
    color: #45b5b5;
    padding: 5px 15px;
    width: 72px;
    font-size: 14px;
    font-weight: 600;
    border-right: 2px solid transparent;
    flex-shrink: 0;
}

.submenu-header:hover{
    border-right: 2px solid #45b5b5;
    background-color: rgba(69, 181, 181, 0.3);
}

.submenu-items {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
}

.submenu-item {
    cursor: pointer;
    font-size: 14px;
    padding: 5px 8px;
    color: rgb(120, 120, 120);
    border: 1px solid transparent;
    flex-shrink: 0;
}

.submenu-item:hover {
    color: #45b5b5;
    background-color: rgba(69, 181, 181, 0.1);
}

.search {
    display: flex;
    width: 100%;
    z-index: 1000;
}

.searchContainer{
    margin: 36px auto;
    position: relative;
    display: inline-block;
}

.searchContainer input{
    font-size: 16px;
    padding: 4px 12px;
    width: 240px;
    border-radius: 24px;
    color: gray;
    border: 1px solid #45B5B5;
}

.searchContainer button{
    font-size: 16px;
    padding: 4px 12px;
    color: #45B5B5;
    background: none;
    border: none;
}

.searchContainer button:hover{
    cursor: pointer;
    color: white;
    background-color: #45B5B5;
    border-radius: 24px;
}

.stylesContainer {
    display: flex;
    width: 100%;
}

.styleRow{
    width: 1280px;
    margin: 8px auto;
    margin-bottom: 0;
    position: relative;
}

.styleItem{
    float: left;
    cursor: pointer;
    font-size: 14px;
    padding: 0 8px;
    color: rgb(120, 120, 120);
    border: 1px solid transparent;
} 

.styleItem:hover{
    color: #45B5B5;
}

.styleItem input{
    accent-color: #45B5B5;
}

</style>